import React from "react";
import { FTLErrorPage } from ".";
export class FTLErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    render() {
        return (React.createElement(FTLErrorPage, { variant: "internalErrorWithRefresh", hasError: this.state.hasError }, this.props.children));
    }
}
//# sourceMappingURL=FTLErrorBoundary.js.map